<template>
    <div style="height: calc(100% - 100px);padding: 5px;" class="hairxflog">
      <el-tabs stretch style="height: 100%">
        <el-tab-pane label="消费日志" style="height: 100%;" >
          <div style="overflow: auto;height: 100%;">
            <el-card class="box-card mycard" v-for="(item,key) in beautyXfLog" :key="key" style="margin-bottom: 10px">
              <div slot="header" style="background-color: rgb(238, 241, 246)" >
                {{$moment(item.accountdate).format('YYYY-MM-DD')}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.cardTransactionHistories[0].cardnumber}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.cardTransactionHistories[0].membername}}
                <div v-for="(val,index) in item.cardTransactionHistories" :key="index">
                  {{val.projectname}}
                </div>
              </div>
              <el-form label-position="top" size="mini" @submit.native.prevent>
                <!--<el-form-item label="提升满意度当天做了什么(讲米兰好，效果呈现，不满意处理)">
                    <el-input type="textarea" v-model="item.beautyXfLog.oparation" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                </el-form-item>-->
                <el-form-item label="服务日志">
                  <el-input type="textarea" v-model="item.beautyXfLog.chat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                </el-form-item>
                <!--<el-form-item label="消耗时铺垫了什么项目(进度)">
                    <el-input type="textarea" v-model="item.beautyXfLog.xhtarget" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                </el-form-item>-->
                <div style="margin-top: 5px;">
                  <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfLog(item,0)" style="width: 60%;">保存</van-button>
                  <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfLog(item,1)" style="width: 30%;float: right;">保存预约</van-button>
                </div>
              </el-form>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="消费回访" style="height: 100%">
          <div style="overflow: auto;height: 100%">
            <el-descriptions direction="vertical" :column="1" border size="mini">
              <el-descriptions-item v-for="(item,index) in hairHfData" :key="index">
                <template slot="label">
                  <div style="margin-bottom: 10px;">
                    <span style="min-width: 200px;display: block;float: left;">{{item.cash.accountdate}}</span>
                    <span style="min-width: 100px;display: block;float: left;" v-if="item.cash.cardnumber">{{item.cash.cardnumber}}</span>
                    <span style="min-width: 100px;display: block;float: left;" v-else>{{item.cash.memberphone}}</span>
                    <span style="min-width: 100px;display: block;">{{item.cash.membername}}</span>
                  </div>
                  <div v-for="(detal,idx) in item.cashDetals" :key="idx">
                    <span style="min-width: 200px;display: block;float: left;">{{detal.projectname}}</span>
                    <span style="min-width: 100px;display: block;float: left;">{{detal.staffname1}}</span>
                    <span style="min-width: 100px;display: block;">{{detal.staffname2}}</span>
                  </div>
                </template>
                <el-form label-width="80px" @submit.native.prevent>
                  <el-form-item label="满意度" style="margin-bottom: 0px;" >
                    <el-radio-group v-model="item.hairRepay.evaluate">
                      <el-radio :label="1">满意</el-radio>
                      <el-radio :label="2">不满意</el-radio>
                    </el-radio-group>
                    <el-button type="primary" size="mini" style="float: right;" :loading="loading" @click="saveHairRepay(item)">保 存</el-button>
                  </el-form-item>
                  <el-form-item label="回访内容" style="margin-bottom: 0px;">
                    <el-input type="textarea" v-model="item.hairRepay.content"></el-input>
                  </el-form-item>
                </el-form>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>
<script>
    export default {
      data() {
        return {
            loading:false,
            brands:[],
            storeid:localStorage.getItem("storeid"),
            loadinglog:true,
            finishedlog:true,
            beautyXfLog:[],
            staffid:"",
          hairHfData:[],
        }
    },
    created() {
        this.staffid=this.$route.query.staffid;
        if(!this.staffid){
            this.staffid=localStorage.getItem("querystaffid");
        }
        this.getNotXfLogCardtransHistory();
        this.getHairHFDetalByStaffId();
    },
    methods:{
        saveHairRepay(item){
          this.loading=true;
          if(item.hairRepay.evaluate==0){
            this.$message({message:"请选择满意度",type: 'error'});
            this.loading=false;
            return;
          }
          if(item.hairRepay.evaluate==2){
            if(!item.hairRepay.content || item.hairRepay.content.length<10){
              this.$message({message:"不满意，请输入原因，且字数不能少于10个字",type: 'error'});
              this.loading=false;
              return;
            }
          }
          let hairRepay=new Object();
          hairRepay.storeid=this.storeid;
          hairRepay.cardid=item.cash.cardid;
          hairRepay.accountdate=item.cash.accountdate;
          let projectname="";
          for(let val of item.cashDetals){
            if(projectname==""){
              projectname=val.projectname;
            }
            else{
              projectname=projectname+","+val.projectname;
            }
          }
          hairRepay.projectname=projectname;
          hairRepay.evaluate=item.hairRepay.evaluate;
          hairRepay.content=item.hairRepay.content;
          hairRepay.createtor=localStorage.getItem("staffid");
          hairRepay.createname=localStorage.getItem("staffname");
          this.$postw("hairwork/saveHairRepay",hairRepay).then(res=>{
            this.loading=false;
            if(res.sucess){
              this.$message({message: "保存成功",type: 'success'});
              this.getHairHFDetalByStaffId();
            }
            else{
              this.$message({message:res.message,type: 'error'});
            }
          });
        },
        getHairHFDetalByStaffId(){
          this.$post("hairwork/getHairHFDetalByStaffId",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
              if(res.sucess){
                  this.hairHfData=res.object;
              }
              else{
                this.$message.error(res.message);
              }
          });
        },
        saveBeautyXfLog(item,type){
                if(!item.beautyXfLog.chat){
                    this.$message.error("请输入服务日志");
                    return;
                }
                let beautyXfLog=new Object();
                beautyXfLog.storeid=item.cardTransactionHistories[0].storeid;
                beautyXfLog.cardid=item.cardTransactionHistories[0].cardid;
                beautyXfLog.memberid=item.cardTransactionHistories[0].memberid;
                beautyXfLog.accountdate=item.accountdate;
                beautyXfLog.oparation=item.beautyXfLog.oparation;
                beautyXfLog.xhtarget=item.beautyXfLog.xhtarget;
                beautyXfLog.chat=item.beautyXfLog.chat;
                beautyXfLog.nextdate=item.beautyXfLog.nextdate;
                let projectname="";
                for(let val of item.cardTransactionHistories){
                    if(projectname!=""){
                        projectname=projectname+","+val.projectname;
                    }
                    else{
                        projectname=val.projectname;
                    }
                }
                beautyXfLog.projectname=projectname;
                this.$postw("hairmanager/saveHairXfLog",beautyXfLog).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getNotXfLogCardtransHistory();
                        if(type==1){
                            this.$router.push({path:"/addhairorder",query:{
                                cardid:item.cardTransactionHistories[0].cardid,
                                cardnumber:item.cardTransactionHistories[0].cardnumber,
                                memberid:item.cardTransactionHistories[0].memberid,
                                membername:item.cardTransactionHistories[0].membername,
                                memberphone:item.cardTransactionHistories[0].memberphone,
                                cardtypeid:item.cardTransactionHistories[0].cardtypeid,
                                sex:item.cardTransactionHistories[0].sex
                            }});
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
        },
        storeChange(val){
            localStorage.setItem("storeid",val);
            this.storeid=val;
            this.getNotXfLogCardtransHistory();
        },
        getNotXfLogCardtransHistory(){
            this.$post("hairmanager/getStaffHairXfLogByStore",{storeid:localStorage.getItem("storeid"),staffid:this.staffid}).then(res=>{
                if(res.sucess){
                    this.beautyXfLog=res.object;
                }
                else{
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
    }
}
</script>

<style style lang="scss" rel="stylesheet/scss">
  .hairxflog .el-tabs__content{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/manager/hairxflog.vue